import React from 'react';
type SkeletonLoaderProps = {
  variant?: 'card' | 'text' | 'circle' | 'rectangle';
  count?: number;
  className?: string;
};
export function SkeletonLoader({
  variant = 'rectangle',
  count = 1,
  className = ''
}: SkeletonLoaderProps) {
  const skeletons = Array.from({
    length: count
  });
  const baseClasses = 'animate-pulse bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:200%_100%]';
  const variantClasses = {
    card: 'rounded-2xl h-64',
    text: 'rounded h-4',
    circle: 'rounded-full',
    rectangle: 'rounded-xl'
  };
  return <>
      {skeletons.map((_, index) => <div key={index} className={`${baseClasses} ${variantClasses[variant]} ${className}`} style={{
      animation: 'shimmer 2s infinite'
    }} data-id="element-1722" />)}
    </>;
}
export function StoryCardSkeleton() {
  return <div className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-1723">
      <SkeletonLoader variant="rectangle" className="aspect-video" data-id="element-1724" />
      <div className="p-6 space-y-3" data-id="element-1725">
        <SkeletonLoader variant="text" className="w-3/4 h-6" data-id="element-1726" />
        <SkeletonLoader variant="text" className="w-full" data-id="element-1727" />
        <SkeletonLoader variant="text" className="w-5/6" data-id="element-1728" />
        <div className="flex items-center gap-2 pt-2" data-id="element-1729">
          <SkeletonLoader variant="circle" className="w-6 h-6" data-id="element-1730" />
          <SkeletonLoader variant="text" className="w-24" data-id="element-1731" />
        </div>
      </div>
    </div>;
}
export function StorybookCardSkeleton() {
  return <div className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-1732">
      <div className="p-6 space-y-4" data-id="element-1733">
        <SkeletonLoader variant="text" className="w-32 h-4" data-id="element-1734" />
        <SkeletonLoader variant="text" className="w-2/3 h-8" data-id="element-1735" />
        <SkeletonLoader variant="rectangle" className="aspect-video" data-id="element-1736" />
        <SkeletonLoader variant="text" className="w-full" data-id="element-1737" />
        <SkeletonLoader variant="text" className="w-4/5" data-id="element-1738" />
      </div>
    </div>;
}